//首页轮播图
export const swiperList = [
    '/status/swiper.jpg'
]
//底部产品分类
export const productClassificationList = [
    '医院信息化系列',
    '智慧护理系列',
    '数据影像系列',
    '互联网医疗系列',
    '健康养老系列'
]
//首页旗下品牌
export const brandsList = [
    {
        text: "顶卫云科技",
        title: '顶卫云科技是以技术研发、产品创新为核心、涵盖网站建设与推广、小程序与APP、互联网营销、大型系统软件开发，涉及到云计算、AI、大数据、移动互联网等技术领域 包含了政企、新零售、在线教育、智能出行、新农业、工程管理、智慧城市、智慧制造、资产、档案管理等行业，为各行各业提供高质量的信息化解决方案，为传统企业数字化转型赋能。',
    },
    {
        text: "顶岳科技",
        title: '顶岳科技是一家专注于一二类医疗器械领域的创新企业，致力于为全球患者提供高品质、安全、可靠的健康产品。不仅拥有强大的研发团队和先进的生产设备，更具备全方位的销售渠道和服务体系。通过持续不断地推动产品创新和市场拓展。',
    },
    {
        text: "岳泰兴大药房",
        title: '岳泰兴大药房作为岳泰兴医疗旗下的品牌，一直秉承着“顾客至上，服务至上”的经营理念，致力于打造全国领先的药品零售和医疗服务平台。其在产品质量、安全性、价格透明度等方面进行了全面的优化和升级，不断提升消费者的购物体验和健康管理水平。同时，岳泰兴药店借助数字化技术，构建起智能化的客户服务系统和供应链管理体系，为患者和医护人员提供更加便捷、高效、个性化的医疗服务，创造了更多的社会价值和商业价值。',
    }
]
//核心产品
export const coreProductList = [
    [{
        id: 1,
        img: '/status/diannao.jpg',
        imgInfo: '/status/hexin/1.jpg',
        name: 'HIS系统',
        info: `医院信息管理系统包括门（急）诊管理、住院管理、药库（房）管理、' +
            '门诊电子处方、住院医嘱管理、电子病历、' +
            '检验等多个管理模块，涵盖了医疗信息管理的各个业务环节`,
    },
        {
            id: 11,
            img: '/status/diannao.jpg',
            imgInfo: '/status/hexin/2.jpg',
            name: '智慧养老',
            info: `智慧养老平台利用“医养一体化”的发展模式，集医疗、康复、养生、养老等为一体化，打造机构养老与居家养老、生活照料与康复关怀相融合的全新智慧养老服务平台`,
        },
        {
            id: 3,
            imgInfo: '/status/yiliao.png',
            img: '/status/diannao.jpg',
            name: '医疗大数据可视化驾驶舱',
            info: `医疗大数据可视化驾驶舱通过分析、筛选，动态展示医疗数据，以直观动态的方式展现海量医疗数据，助力医疗机构实现数据驱动的决策优化，提升运营效率与患者满意度，能够实时监控关键指标，提供深入的数据分析，并通过交互式界面，使复杂的医疗信息一目了然，从而提高医疗服务的质量和效率，是智慧医疗不可或缺的重要工具。`,
        }, {
        id: 4,
        img: '/status/diannao.jpg',
        imgInfo: '/status/hexin/3.jpg',
        name: '智慧医院',
        info: `实现医院管理、医疗服务、患者就医等各个环节的数字化转型和升级。智慧医院的建设旨在提高医疗服务效率和质量，优化患者就医体验，降低医疗成本。`,
    }],
    [{
        id: 5,
        img: '/status/diannao.jpg',
        imgInfo: '/status/hexin/4.jpg',
        name: '智慧病房',
        info: `智慧病房综合解决方案，包含（床头呼叫终端、病房门口屏、卫生间呼叫器、护士站管理主机等）`,
    },
        {
            id: 6,
            img: '/status/diannao.jpg',
            imgInfo: '/status/hexin/5.jpg',
            name: '移动护理',
            info: `以手持PDA为主的智慧病房综合解决方案`,
        },
        {
            id: 7,
            img: '/status/diannao.jpg',
            imgInfo: '/status/hexin/6.jpg',
            name: '智能输液监测',
            info: `输液监测，大屏展示`,
        }, {
        id: 8,
        img: '/status/diannao.jpg',
        imgInfo: '/status/hexin/7.jpg',
        name: '住院床旁交互',
        info: `信息呈现与交互:<br>
            1.床头卡:显示医院科室基本信息(医院LOGO，科室名字，床位号等)<br>
            2.病人基本信息(姓名、性别、年龄、入院时间，住院号)、责任医生和责任护士、医嘱信息(护理等级，饮食状况，过敏信息、护理标签等)、警示标语或时间信息等<br>
            3.健康资讯：医院可通过后发布官方信息，也可对接医院微信公众号推送消息<br>
            4.音视频对讲:语音对讲医护收到病房头智能终端的呼叫提醒后可接听，并跟与其进行音视频对讲医护通过护士站主机可直接呼叫智能终端并与之音视频对讲<br>
            5.语音广播:医护可通过护士主机和全科室床旁智能终端或指定床位的床头终端进行语音广播<br>
            6.消息提醒<br>
            7.患者告知 <br>
            8.病程管理 医嘱查看：可从HIS或移动护理系统接入医嘱信息，包括医嘱的开始时间、医嘱内容、一次使用剂量、计量单位、医嘱状态等 <br>
            10.问卷调查 患者可对医院综合服务、医生、护士等进行满意度评价<br>
            健康宣教:(需付费)<br>
            1.视频宣教:患者可查看健康宣教视频，比如入住须知，出院提醒，手术提醒等<br>
              2.图文宣教:患者可查看公共类图文类宣教资料<br>
            3.认识医院:支持以图文的形式显示医院官网链接、院内信息呈现、全院通知公告推送等<br>
            4.科室介绍:支持以图文的形式显示科室介绍<br>
            5.医护风采:支持以图文的形式显示医护介绍<br>
        影音娱乐:<br>
            1.音乐欣赏:支持本地音频资源播放（提供管理后台，医院进行内容维护）<br>
            2.小游戏:支持本地小游戏体验（提供管理后台，医院进行内容维护）<br>
            3.电子书:支持本地电子书资源阅览（提供管理后台，医院进行内容维护）<br>
            4.视频点播:支持本地视频资源播放（提供管理后台，医院进行内容维护）<br>
            5.电视直播:患者可以通过终端观看电视直播频道(需IPTV信号接入及外购多媒体网关) <br>
            精准护理:<br>
            ▲呼叫统计表 统计呼叫相关数据(呼叫发起者，发起时间，护理相应时间)，数据可追溯，方便对医患纠纷的处理<br>
            ▲呼叫统计图 按照日/月统计呼叫频率和护理相应时间，方便护士长做数据决策、统计患者入住到离院呼叫频率和护理相应时间，有利于患者入住体验的分析<br>
            系统运维:<br>
            ▲设备禁用 护士可以控制终端设备禁用时间，避免病患过度使用设备影响病情或干扰其他人休息<br>
            ▲批量升级 终端系统可以方便地进行系统软件批量升级<br>
            ▲状态监控 可以监控患者终端设备状态<br>
            ▲断网重连 在网络异常下，能够较好的改善患者使用的体验感`,
    }],
    [{
        id: 9,
        imgInfo: '/status/hexin/8.jpg',
        img: '/status/diannao.jpg',
        name: '智慧门诊系统',
        info: `对门诊流程进行智能化改造和优化，实现患者挂号、就诊、缴费、取药等环节的便捷化和高效化。智慧门诊的建设旨在提升医疗服务质量，改善患者就医体验，降低医疗成本。`,
    },
        {
            id: 50,
            imgInfo: '/status/hexin/18.jpg',
            img: '/status/diannao.jpg',
            name: '医院智能电话客服系统',
            info: `医院智能电话客服系统`,
        },
        {
            id: 51,
            img: '/status/hexin/19.png',
            name: '壁挂取号终端',
            info: `壁挂取号终端`,
        },
        {
            id: 52,
            img: '/status/hexin/20.png',
            name: '窗口呼叫终端',
            info: `窗口呼叫终端`,
        },
        {
            id: 53,
            img: '/status/hexin/21.png',
            name: '窗口显示终端',
            info: `窗口显示终端`,
        },
        {
            id: 54,
            img: '/status/hexin/22.png',
            name: '等候显示终端',
            info: `等候显示终端`,
        },
        {
            id: 55,
            img: '/status/hexin/23.png',
            name: '立式取号终端',
            info: `立式取号终端`,
        },
        {
            id: 56,
            img: '/status/hexin/24.png',
            name: '门诊显示终端',
            info: `<img style="margin-top: 20px;margin-left: 20px;width: 200px;height: 250px" src="/status/hexin/25.png">`,
        },
        {
            id: 57,
            img: '/status/hexin/26.png',
            name: '排队显示终端',
            info: `排队显示终端`,
        },
        {
            id: 58,
            img: '/status/hexin/27.png',
            name: '自助服务终端',
            info: `
            <img style="margin-top: 20px;margin-left: 20px;width: 180px;height: 250px" src="/status/hexin/28.png">
<img style="margin-top: 20px;margin-left: 40px;width: 180px;height: 250px" src="/status/hexin/29.png">
<img style="margin-top: 20px;margin-left: 40px;width: 180px;height: 250px" src="/status/hexin/30.png">`,
        },],
    [{
        id: 10,
        // img: '/status/diannao.jpg',
        img: '/status/hexin/9.png',
        name: '互联网医院',
        info: `互联网医院是建立以医院为主体的互联网医疗服务平台，构建
            “线上预诊一线下面诊与治疗一线上复诊”的新型医疗模式。
            提供云诊室，建设面向患者的移动互联网服务平台。`,
    },
        {
            id: 2,
            // img: '/status/diannao.jpg',
            name: '云胶片',
            img: '/status/hexin/10.png',
            info: `岳泰兴云胶片系统基于移动互联网和云储存技术，将患者的影像诊断报告和全部的DICOM影像存储在云端的，通过二维码、公众号、短信链接等多种渠道在多种终端设备上调阅浏览，让医疗数据全方位的展现。`,
        },],
    [
        {
            id: 12,
            img: '/status/yiliaoqixie/1.png',
            name: '新型 64 排 AI “炫速”螺旋 CT',
            info: `精准:13 档KV,10KV 步进，新球管 ATHLON 定制化扫描。<br/>精纯:KV能谱纯化技术,平片剂量、高清影像。<br/>炫速:0.33秒/360°扫描速度，掌上全新扫描流程，隔室遥控操作。<br/>精智:诊立得，智能图像处理，即拍及诊断，无需医生任何操作`,
        },
        {
            id: 13,
            img: '/status/yiliaoqixie/2.png',
            name: 'SOMATOM GO.NOW',
            info: `全球首台掌上筛查CT<br/>AI人工智能CT<br/>高效、低成本运营`,
        },
        {
            id: 14,
            img: '/status/yiliaoqixie/3.png',
            name: '珠穆--DX6290动态悬吊系列',
            info: `悬吊静态  床式动态<br/>CT+核磁<br/>17X17英寸<br/>940万像素<br/>0.8s极速高清点片`,
        },
        {
            id: 15,
            img: '/status/yiliaoqixie/4.png',
            name: 'DTP580臂式动态平板系列',
            info: `譬式多功能诊断专用动态DR<br/>SID支持1M至1.8M,轻松调定各种角度投照。<br/>专业尘肺处理软件，为用户量身定制<br/>动志极速切换，解决姐织结构影像重叠的拍片痛点<br/>·17X17的大视野动态观察，能更全局的观察病患部位，减少漏诊。`,
        },
        {
            id: 16,
            img: '/status/yiliaoqixie/5.png',
            name: '疾光--行业高端动态双立柱DR',
            info: `高清动态平板探测器<br/>·17X17英寸/940万像素/0.8S级<br/>速动静切换/25fps 双板均可移动<br/>智能运动控制 摄片更高效:<br/>探测器、球管双向自动跟踪/业界首<br/>个手电一体控制床面四向运动/业<br/>·界管个1250MM超大范国滤线栅移动<br/>创新人性化操作流设计<br/>·10.4英寸智能触控大屏/立柱顶部<br/>环绕式灯带设计/智能急诊与体检登记`,
        },
        {
            id: 17,
            img: '/status/yiliaoqixie/66.png',
            name: '奇光 DTP520臂式动态平板系列',
            info: `全方位360”电动旋转站台<br/>医生可隔室通控病人转体进行摆位，提升查体<br/>效率的同时，提升诊断精度<br/>电动+手动运动控制设计<br/>电动+手动双重控制，让临床摆位精准高效。<br/>探测器旋转范围-45°~45°<br/>满足临床特殊角度X线摄影摆位需要<br/>横臂旋转范围0°~135°<br/>满足临床立位、卧位等各类投照拍摄需求<br/>SID可调范围1M~1.8M<br/>满足各种专业规范摄影摆位要求。<br/>配备业界超低640MM诊断床<br/>采用中控设计,可一步固定或解锁,病人轻松上、下床。`,
        },
        {
            id: 18,
            img: '/status/yiliaoqixie/7.png',
            name: '四维多功能牵引床(新款)HKHL-JYZ-V四维(无间隙牵引)配颈牵',
            info: `四维立体全方位牵引功能,颈椎牵引,牵引床无间隙,功能具备上成牵引、下成角牵引,左、右旋转牵引<br/>,左、右侧平摆牵引及纵向牵引功能;<br/>电脑控制颈椎牵引,有持续牵引、反复牵引等八种牵引治疗模式,具备牵引力自动补偿功能;<br/>计算控制,中文显示,任意设定参数;<br/>两套操系统，可与电连接同步作运行。`,
        },
        {
            id: 19,
            img: '/status/yiliaoqixie/118.png',
            name: '体外冲击波治疗仪 SC-CJ-2000(双通道)触摸屏款',
            info: `10.4英寸真彩色高分辨触摸屏设计,显示直观,操作简便;<br/>双通道可同时输出治疗,互相独立,互不干扰;治疗界面、处方界面、<br/>待机界面可自由切换,方便实时监控治疗状态;治疗枪拆卸简便,客户可自行维护;<br/>机身整体美观大气,治疗枪控制手柄符合人体工学设计,轻巧便捷,治疗师操作简单。`,
        },
        {
            id: 20,
            img: '/status/yiliaoqixie/99.png',
            name: '吞咽神经和肌肉电刺激仪 SC-TY-4000B(双通道)',
            info: `吞咽障碍是由于下颌、双唇、舌、软腭、喉、食道上括约肌或食道功能受损所致的进食障碍。<br/>将主电极放置于患者的颈喉部,对喉返神经、舌下神经、舌咽神经等吞咽神经与吞咽功能相关<br/>的神经进行电刺激,实现吞咽和言语反射弧的恢复与重建,提高患者吞咽及构音肌群的活动能力,<br/>进而提高吞咽及语言的活动能力。`,
        },
        {
            id: 21,
            img: '/status/yiliaoqixie/100.png',
            name: '经颅磁治疗仪 SC-JL-4000(触摸款)',
            info: `经颅磁刺激仪是通过特定磁场原理,作用于脑细胞和<br/>中枢神经上;激活处于抑制状态的脑细胞，改善脑细胞<br/>的代谢环境,增加代谢酶的活性,使受损的脑细胞代谢增快，<br/>增加损伤细胞的可修复性;进而达到镇静、安神、促进睡眠和<br/>抗抑郁、抗焦虑、消除神经衰弱、缓解脑疲等,高端触摸屏操作。`,
        },
        {
            id: 22,
            img: '/status/yiliaoqixie/111.png',
            name: '磁振热治疗仪 SC-CZ-4000',
            info: `四路输出;磁振热治疗采用磁场、振动、温热三种物理因子相结治疗方式，<br/>可改善局部血液循环,扩张血管,加速炎性渗出吸收;降低末梢神经的兴奋性，<br/>有效缓解肌肉的僵硬、疲劳和疼痛;人体在磁场中,可加强大脑皮层的抑制过程<br/>调节植物神经的功能。一体柜式机支持多人多部位治疗。`,
        },
        {
            id: 23,
            img: '/status/yiliaoqixie/122.png',
            name: '中频治疗仪BA2008-III',
            info: `中频治疗仅是传统的低中频电疗技术与现代电脑数控技术相结合的先进治疗设备。它主要经过程序处<br/>方电流序法镇痛。缓解软绢织损伤、消除运动后疲劳、扭伤、挫伤、腰痛、颈椎痛、肩周炎、功能性电刺激。<br/>消炎、消肿软化癫痕改善局部组织血液环的作用。四路同步、异步治疗,具备离子导入道、十扰电通道。`,
        },
        {
            id: 24,
            img: '/status/yiliaoqixie/133.png',
            name: '颈椎牵引机HKHL-JZ-4(豪华电脑+中频+按摩)',
            info: `微电脑控制颈椎牵引，牵引力自动补偿功能;<br/>具备牵引力过大自动保护功能;<br/>具备通过手动按钮调整牵引力大小的功能,且可做牵引前的自动预拉紧功能;<br/>配备颈部固定装置、中频电疗、颈部机械按摩功能、腰部按摩装置及红外热疗功能。`,
        },
        {
            id: 25,
            img: '/status/yiliaoqixie/144.png',
            name: '低频电子脉冲治疗仪SC-DP-6000',
            info: `低频脉冲电流能直接刺激神经肌肉组织，有效引起肌肉兴奋和收缩，<br/>通过交互刺激使痉挛肌肉得以放松，改善部位功能，电极片4个<br/>电机线2套,吸附电极4个,吸附电极线2套,具有两通道单独或同时治疗的功能,<br/>电极片和吸附碗两种方式。`,
        },
        {
            id: 26,
            img: '/status/yiliaoqixie/155.png',
            name: '红外偏振光治疗仪 SC-PZ-3000触摸屏',
            info: `通达到抑制神兴奋性,松弛肌肉的作用,红外偏振光可通过阻断疼痛<br/>恶性循环和改善血液循环,治疗疼痛性疾病,消除炎症和水肿;红外偏<br/>振光作用于神经节、神经根、神经干、穴位和局部痛点调解人体内环境的稳定<br/>使各系统趋于正常的生理平衡;双集射治疗头。`,
        },
        {
            id: 27,
            img: '/status/yiliaoqixie/166.png',
            name: '中药熏蒸治疗机HKHL-XZ-II(新式)',
            info: `独立的三个温区恒温控制;<br/>具有自动漏电保护、自动防干烧、自动报警、自动定时、自动恒温等功能;三区各自具备独立的自动送暖风装置;<br/>三区温度独立控制调节;<br/>抗菌、耐磨、耐热;<br/>进口食品级玻璃全身式熏蒸罩。`,
        },
        {
            id: 28,
            img: '/status/yiliaoqixie/177.png',
            name: '密闭煎药变量包装一体机(I型)HKHL-BL200II',
            info: `变量包装,包装容量随意调节;<br/>数字化微电脑设计,数字显示,操作界面人性化,性能稳定;<br/>全不锈钢机箱,经久耐用,耐腐蚀,永不生锈,美观大方;<br/>不锈钢煎药锅,配有安全阀,压力表,密闭煎药无挥发,药效充分提取。`,
        },
        {
            id: 29,
            img: '/status/yiliaoqixie/188.png',
            name: '密闭煎药变量包装一体机(II型)HKHL-BL200III',
            info: `数字化微电脑设计,液晶显示,触摸控制,操作界面人性化,性能穩定;<br/>全不锈钢机箱,经久耐用、耐腐蚀、永不生诱,美观大方;<br/>不锈钢煎药锅,配有安全阀,压力表,密闭煎药无挥发,药效充分提取;<br/>同时可煎3个处方。`,
        },
        {
            id: 30,
            img: '/status/yiliaoqixie/199.png',
            name: '全自动制丸机HKHL-80',
            info: `采用双螺杆,无需翻料板，直接进料搅拌,无需人工干预自动进料;<br/>滚轴表面不粘处理,无需加酒精;<br/>一次出多条,提高3倍效率;<br/>快速可更换不同滚轴组从而达到制备各种丸剂大小。`,
        },
        {
            id: 31,
            img: '/status/yiliaoqixie/200.png',
            name: '超短波电疗机BA-CD-II(连续、脉冲型)',
            info: `该产品将输出的高频电场作用于人体病灶部位，通过超短波离频电磁震荡效应<br/>热效应和非热效应，对脑、并脑的各种炎症性消炎;<br/>使源度内脏血管扩张;<br/>促进胃肠分泌和吸收，解除肠胃痉率;<br/>解除得血管痉挛,有显著的利尿作用;<br/>促进肉芽组织和结蒂组织再生;<br/>对消除炎痘有良好的作用,特别是可以使用本产品的脉冲功能,冶疗急性化膝性炎症。`,
        },
    ],
    [
        {
            id: 32,
            img: '/status/hexin/16.png',
            name: '智慧心理自助系统横屏',
            info: `智慧心理自助系统横屏`,
        },
        {
            id: 33,
            img: '/status/hexin/17.png',
            name: '智慧心理自助系统竖屏',
            info: `智慧心理自助系统竖屏`,
        },
    ],
    [
        {
            id: 34,
            img: '/status/hexin/12.png',
            name: 'AI中医脉诊机器人',
            info: `AI中医脉诊机器人`,
        },
        {
            id: 35,
            img: '/status/hexin/13.png',
            name: 'AI中医面诊机器人',
            info: `AI中医面诊机器人`,
        },
        {
            id: 36,
            img: '/status/hexin/14.png',
            name: 'AI中医舌诊机器人',
            info: `AI中医舌诊机器人`,
        },
        {
            id: 37,
            img: '/status/hexin/15.png',
            name: 'AI中医问诊机器人',
            info: `AI中医问诊机器人`,
        },
    ],
    [
        {
            id: 38,
            img: '/status/hexin/11.png',
            name: '儿童感觉统合评估训练系统',
            info: `儿童感觉统合评估训练系统`,
        },
        {
            id: 39,
            img: '/status/hexin/11.png',
            name: '儿童孤独症及行为干预系统',
            info: `儿童孤独症及行为干预系统`,
        },
        {
            id: 40,
            img: '/status/hexin/11.png',
            name: '儿童体格发育评估系统',
            info: `儿童体格发育评估系统`,
        },
        {
            id: 41,
            img: '/status/hexin/11.png',
            name: '儿童心理脑功能(认知)评估训练系统',
            info: `儿童心理脑功能(认知)评估训练系统`,
        },
        {
            id: 42,
            img: '/status/hexin/11.png',
            name: '儿童心理脑功能(言语)评估训练系统',
            info: `儿童心理脑功能(言语)评估训练系统`,
        },
        {
            id: 43,
            img: '/status/hexin/11.png',
            name: '老年人康复脑功能评估训练系统',
            info: `老年人康复脑功能评估训练系统`,
        },
        {
            id: 44,
            img: '/status/hexin/11.png',
            name: '神经康复脑功能评估训练系统',
            info: `神经康复脑功能评估训练系统`,
        },
        {
            id: 45,
            img: '/status/hexin/11.png',
            name: '听视觉注意力脑功能评估训练系统',
            info: `听视觉注意力脑功能评估训练系统`,
        },
        {
            id: 46,
            img: '/status/hexin/11.png',
            name: '心理脑功能(言语)评估训练系统',
            info: `心理脑功能(言语)评估训练系统`,
        },
        {
            id: 47,
            img: '/status/hexin/11.png',
            name: '心理脑功能认知障碍评估与训练系统',
            info: `心理脑功能认知障碍评估与训练系统`,
        },
        {
            id: 48,
            img: '/status/hexin/11.png',
            name: '心理脑功能失语障碍评估与训练系统',
            info: `心理脑功能失语障碍评估与训练系统`,
        },
        {
            id: 49,
            img: '/status/hexin/11.png',
            name: '营养配餐分析系统',
            info: `营养配餐分析系统`,
        },
    ]


]
//招聘
export const talentList = [
    {
        id: 1,
        name: '药店店长',
        address: '湖南省雨花区',
        num: '10',
        info: {
            zhize: `<p>1、大专及以上学历，市场营销等相关专业，有能力不限；</p>
                    <p>2、年连锁药店区域运营经验；</p>
                    <p>3、反应敏捷、表达能力强，具有较强的沟通能力及交际技巧，具有亲和力；</p>
                    <p>4、具备一定的市场分析及判断能力，良好的客户服务意识；</p>
                    <p>5、有责任心，能承受较大的工作压力；</p>
                    <p>6、公司化运营，高薪诚聘，适合的可以直接过来公司面试，工作地点就近安排。</p>
                    `,
            yaoqiu: `<p>1、负责药店运营；</p>
                     <p>2、根据市场营销计划，完成销售指标；</p>
                     <p>3、开拓其他区域新市场,发展新客户,增加药品销售范围；</p>
                     <p>4、负责运营区域销售活动的策划和执行；</p>
                     <p>5、负责辖区市场商品品类，价格信息的收集及竞争对手的分析；</p>
                     <p>6、管理维护客户关系以及客户间的长期战略合作计划；</p>
                     <p>7、能积极配合及完成上级下达的各项任务指标。</p>
                        `,
        }
    },
    {
        id: 2,
        name: '电商运营',
        address: '湖南省雨花区',
        num: '3',
        info: {
            zhize: `<p>1、熟悉平台营销规则，了解用户的购物习惯和心理，并具有良好的在线销售能力，</p>
                    <p>2、能对店面布局和版面的改善提出持续的跟进意见，，</p>
                    <p>3、敢于挑战自我，热爱网络销售及推广工作，对电子商务发展有清晰的认识，创新意识较强，</p>
                    <p>4、较好的人际沟通能力、组织协调能力和应变能力，具有强烈的责任心和事业心；</p>`,
            yaoqiu: `<p>1、负责网店整体规划、营销、推广、客户关系管理等系统经营性工作，</p>
                     <p>2、负责商品标题、广告语详情优化，以获得更多自然流量，提高成交率，</p>
                     <p>3、具备创新能力，富有激情和创意，不断寻找新思路、新方法，提高公司电子商务平台的知名度，</p>
                     <p>4、负责网店日常改版策划、上架、推广、销售、售后服务等经营与管理工作，每日监控的数据包括但不限于营销数据、交易数据、商品管理、客户管理，</p>`,
        }
    },
    {
        id: 3,
        name: '销售经理',
        address: '湖南省雨花区',
        num: '10',
        info: {
            zhize: `<p>1、专科及以上学历，有医药、耗材、医疗设备销售经验者优先；</p>
                    <p>2、具有较强的独立工作能力和社交技巧，较好的沟通能力、协调能力和团队合作能力；</p>
                    <p>3、身体健康，热爱销售工作，能适应湖南省范围内的短期出差、能接受因工作需要的加班、应酬；</p>
                    <p>4、熟练使用基础办公软件、具备较好的理解和表达能力，家庭农村出身者优先考虑,能力优秀者可适当放宽要求。</p>`,
            yaoqiu: `<p>1、通过学术会议推广公司代理产品；</p>
                     <p>2、在辖区内医院进行公司产品的推广销售和相关信息收集，协调好各层关系，完成销售任务；</p>
                     <p>3、根据需要拜访医护人员，向客户推广产品，不断提高产品市场份额；</p>
                     <p>4、开拓潜在的医院渠道客户，并对既有的客户进行维护；</p>
                     <p>5、充分了解市场状态，及时向公司相关负责人反映竞争对手的情况及市场动态、提出合理化建议；</p>
                     <p>6、制定并实施辖区医院的推销计划，组织医院内各种推广活动；</p>
                     <p>7、树立公司的良好形象， 对公司商业秘密做到保密；</p>
                     <p>8、组建自己的销售团队，并进行培养和管理。</p>
                        `,
        }
    },
    {
        id: 4,
        name: '高薪诚聘网店运营美工',
        address: '湖南省雨花区',
        num: '3',
        info: {
            zhize: `<p>1、个人熟悉淘宝基本规则，了解淘宝营销工具及各类推广工具的使用；</p>
                    <p>2、熟悉网店的运营环境等。</p>
                    <p>3、拥有1年以上实操运营经验和团队管理经验。</p>
                    `,
            yaoqiu: `<p>1、负责网店整体规划、营销、推广、客户关系管理等系统经营性工作；</p>
                     <p>2、负责网店日常改版策划、上架、推广、销售、售后服务等经营与管理工作；</p>
                     <p>3、负责网店日常维护，保证网店正常运作，优化店铺和商品排名；</p>
                     <p>4、每日监控的数据：营销数据、交易数据、商品管理、顾客管理 。</p>
                     <p>5、负责执行与配合公司相关营销活动，策划店铺促销活动方案；</p>
                     <p>6、美工，会PS,处理图片，有独特的想法</p>
                        `,
        }
    },
    {
        id: 5,
        name: '岳泰兴医疗高薪诚聘财务会计',
        address: '湖南省雨花区',
        num: '2',
        info: {
            zhize: `<p>1、财务，会计，经济等相关专业大专以上学历，具有会计任职资格；</p>
                    <p>2、具有扎实的会计基础知识和一年以上财会工作经验，并具备一定的英语读写能力；</p>
                    <p>3、熟悉现金管理和银行结算，熟悉用友或其他财务软件的操作；</p>
                    <p>4、具有较强的独立学习和工作的能力，工作踏实，认真细心，积极主动；</p>
                    <p>5、具有良好的职业操守及团队合作精神，较强的沟通、理解和分析能力。</p>
                    `,
            yaoqiu: `<p>1、申请票据，购买发票，准备和报送会计报表，协助办理税务报表的申报；/p>
                     <p>2、现金及银行收付处理，制作记帐凭证，银行对帐，单据审核，开具与保管发票；</p>
                     <p>3、协助财会文件的准备、归档和保管；</p>
                     <p>4、固定资产和低值易耗品的登记和管理；</p>
                     <p>5、负责与银行、税务等部门的对外联络；</p>
                     <p>6、协助主管完成其他日常事务性工作。</p>
                        `,
        }
    },
    {
        id: 6,
        name: '医疗器械销售',
        address: '湖南省雨花区',
        num: '20',
        info: {
            zhize: `<p>1、医学、医药类相关专业优先；</p>
                    <p>2、有医疗器材销售经验者优先；</p>
                    <p>3、热爱销售岗位，有清晰的个人认识和职业规划；</p>
                    <p>4、工作积极主动、性格外向、善于沟通、有亲和力，能承受一定的压力</p>
                    <p>5、大专以上学历优先考虑</p>
                    `,
            yaoqiu: `<p>1、完成市场客户覆盖，建立起所辖区域内的详细市场信息，协助上级管理及维护销售渠道；</p>
                     <p>2、负责在责任区域进行销售工作，完成个人销售指标，负责责任区域内的应收账款；</p>
                     <p>3、执行新产品、新市场的开拓计划、提高产品的市场覆盖率；</p>
                     <p>4、了解所辖区域内的主要竞争对手；</p>
                     <p>5、负责产品的价格体系的管控、渠道建设、推广方案的制定与实施；</p>
                     <p>6、充分了解市场状态，及时向上级主管反映竟争对手的情况及市场动态、提出合理化建议；</p>
                     <p>7、树立公司的良好形象， 对公司商业秘密做到保密。</p>
                        `,
        }
    }]
//企业资讯
export const enterpriseList = [
    {
        id: 20,
        img: '/enter/4.png',
        text: '喜讯 | 湖南岳泰兴医疗科技荣获省级"专精特新"认证，匠心深耕医疗科技新未来！​',
        info: `
            <div style="font-size: 30px;text-align: center;font-weight: bold">湖南省专精特新中小企业认证</div>
            <img style="margin-top: 20px;margin-bottom: 20px;text-align: center;margin-left: 50px" src="/enter/31.png" alt="">
            <img style="margin-top: 20px;margin-bottom: 20px;text-align: center;margin-left: 120px" src="/enter/32.jpg"><br>
               <div style="margin-left: 30px;margin-top: 20px;font-size: 18px;"> 湖南省工业和信息化厅正式公布2025年度湖南省“专精特新”中小企业名单，湖南岳泰兴医疗科技有限公司凭借其卓越的技术创新能力、专业化的医疗产品服务及行业领先优势，成功通过认证！这一荣誉不仅是对企业的高度认可，更标志着公司在医疗科技领域的深耕迈入全新发展阶段。</div>
               <div style="font-size: 30px;text-align: center;font-weight: bold;margin-top: 20px;">用科技推动人类健康</div>
               <div style="margin-top: 20px;margin-left: 30px;">湖南省工业和信息化厅正式公布2025年度湖南省“专精特新”中小企业名单，湖南岳泰兴医疗科技有限公司凭借其卓越的技术创新能力、专业化的医疗产品服务及行业领先优势，成功通过认证！这一荣誉不仅是对企业的高度认可，更标志着公司在医疗科技领域的深耕迈入全新发展阶段。</div>
`,
        time: '2025-05-20',
    },
    {
        id:7,
        img: '/enter/19.png',
        text: '岳泰兴医疗科技：春季招聘，职等你来',
        info: `
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司简介<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;湖南岳泰兴医疗科技有限公司是一家致力于大健康领域的高新技术企业，自成立以来，始终秉承“用科技服务人类健康”的理念，推动大健康事业的发展。同时，公司也积极响应国家“互联网+医疗健康”的政策，持续推动技术创新和产品升级。<br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/19.png" alt=""><br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在产品研发方面，岳泰兴医疗科技紧跟时代步伐，深度融合人工智能、大数据、云计算、物联网等前沿技术，推出了多款具有自主知识产权的产品。核心围绕医疗机构信息化系统建设与康复理疗设备研发生产销售，拥有岳泰兴智慧导诊导航一体机、岳泰兴大健康商城平台、岳泰兴智慧医院、岳泰兴互联网医院、岳泰兴智慧养老、岳泰兴多种康复理疗设备康养产品等产品体系，数智化布局运营线上线下。<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;招聘岗位<br>
电商运营<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1-负责电商的运营（淘宝、拼多多等），包括产品上架、维护和优化页面，制定关键词等，完成销售目标；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2-掌握市场动态，快速响应热点，快速测款及库存控制，制定营销策略，对销售数据进行跟踪监控；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3-协助完善公司电商平台运营的政策和流程，保持平台的好评率和信用度；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4-制定产品渠道传播策略，跨部门沟通，完善渠道数据。<br>
薪资：面谈<br>
电商客服<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、负责淘宝/拼多多店铺的售前/售后客服工作；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、通过在线聊天工具与客户沟通，解答顾客对产品的疑问，处理差评、投诉等；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、及时、有效地解答客户的问题；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、熟悉电商平台聊天的规则与方法；<br>
薪资：面谈<br>
销售经理<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、维护现有医疗渠道资源，与现有医院资源保持良好的关系；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、开发各级医院，建设并维护重点产品相关的专家网络，培养产品意见领袖；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、完成销售业绩指标，根据公司业务需求与医务人员、代理商、医疗机构、企事业单位等达成合作，持续成单；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、负责市场及产品信息（含友商产品）的收集、分析及调整反馈，有效传达产品知识与市场策略，确保区域市场的人员对策略的理解和执行；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、维护及开发区域内的渠道代理商，督促代理商开单、向代理商反馈使用者情况；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6、根据业务需求，向医务人员、代理商、企事业机构等相关人员提供产品相关领域知识、产品使用、产品适用人群、产品策略等培训服务；<br>
薪资：面谈<br>
行政助理<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. 负责文宣和公司相关普及性工作；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. 协助部门主管完成团队考勤，绩效等；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3. 完成领导交代的工作安排承上肩下（弹性）；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4. 协助主管工作；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5. 负责公司新人招聘；<br>

薪资：面谈<br>
设计师<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、负责公司移动端、PC端产品UI设计、改版，为新产品与新功能提供创意及设计方案；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、按时按需独立完成设计工作，能独立设计项目的各个环节，包括切图、标注、视觉测试保证上线效果；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、与团队成员共同完成UI相关设计工作，能根据产品的设计思路设计对应配套的UI；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、参与产品构思及软件界面优化，提出对产品界面规划的见解，对现有产品进行易用性改善，新功能挖掘，把控产品最终界面实现效果；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、熟悉用户使用习惯，重视用户体验，有自己的交互认知及见解；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6、熟悉摄影与视频剪辑<br>

薪资：面谈<br>
产品经理<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、对接产品需求，负责产品前期调研，包括需求收集、分析和定义；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、完成产品原型设计（主要）、需求分析等相关文档的撰写；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、不定期进行竞品分析，对自身产品优化升级；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、大专及以上；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、思维敏捷、逻辑清晰，具备较强的责任心与学习能力；<br>

薪资：面谈<br>
后端工程师<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、根据业务需求,参与软件设计、开发、优化、和维护；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、具有良好的团队合作精神和责任心；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、Java基础扎实，熟悉Spring Boot/Spring Cloud/Mybatis等主流开发框架，对JVM及框架背后的机制和原理有深入理解；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、熟悉Web开发、网络编程、多线程并发编程，熟悉常用的设计模式，熟悉关系型数据库，熟悉分布式缓存、消息等中间；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、熟练使用MySQL、Oracle等；<br>

薪资：面谈<br>
前端工程师<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、能根据产品原型完成项目前端开发；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、负责产品前端开发，解决前端代码问题；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、2年以上Web前端工作经验，大专以上学历；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、精通html、css、js、es6，对各浏览器兼容有丰富经验，熟悉浏览器性能优化；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、精通vue、vuex、vue-router和axios等vue全家桶；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6、熟悉前端工程化，模块化，前后端分离；<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7、熟练掌握ai编程工具；<br>
薪资：面谈

`,
        time: '2025-03-06',
    },

    {
        id: 1,
        img: '/enter/29.png',
        text: '喜报！岳泰兴医疗科技荣获国家高新技术企业认证',
        info: `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近日，岳泰兴医疗科技公司荣获国家高新技术企业认定！这是对公司多年来在医疗科技领域持续创新、追求卓越的高度认可，也是对我司持续投入科技研发和创新的肯定。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<div style="font-weight: bold;text-align: center;font-size: 18px">01第二批高新技术企业拟进行备案的公示</div><br>
            <img style="margin-top: 20px;margin-bottom: 20px;text-align: center;" src="/enter/29.png" alt="">
            <img style="margin-top: 20px;margin-bottom: 20px;text-align: center;margin-left: 200px" src="/enter/30.png"><br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作为一家专注于医疗大健康科技研发的企业，岳泰兴医疗科技一直致力于推动医疗大健康行业的发展。公司拥有一支高素质、专业化的研发团队，不断投入研发，推出了一系列具有自主知识产权的医疗科技产品，为客户提供了更加便捷、高效、安全的医疗服务。<br>
               <div style="font-weight: bold;margin-left: 30px;margin-top: 20px;font-size: 18px;text-align: center"> 用科技推动人类健康</div>
               <div style="margin-top: 20px;">此次获得国家高新技术企业认定，是对岳泰兴医疗科技技术创新能力和成果的认可。公司将继续秉承“用科技推动人类健康”的理念，推动世界医疗大健康事业发展，不断加强技术研发，提升产品品质，为医疗行业的发展贡献更多的力量，成为大健康行业佼佼者。</div>
                `,
        time: '2023-12-22',
    },

    {
        id: 1,
        img: '/enter/3.png',
        text: '上下一心，春暖花开',
        info: `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2月25日，因为公司董事长对门店一线员工的挂念和关怀，也为了鼓舞员工士气，湖南岳泰兴医疗器械有限公司董事长晏岳军一行前往岳泰兴各药房门店慰问督导，并送去疫情防控慰问金。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;董事长晏岳军先生对大家在非常时期能够坚守岗位、履职尽责，表示衷心的感谢，感谢大家能够不计个人得失，克服个人困难，服从大局，坚决服从公司安排，做到忠于职守。同时，晏岳军先生表示：大家在值班期间在工作和生活中还有什么困难，尽管向公司反映，公司会全力以赴，尽快落实解决。<br>
            <img style="margin-top: 20px;margin-bottom: 20px" src="/enter/1.png" alt="">
            <img style="margin-top: 20px;margin-bottom: 20px" src="/enter/2.png"><br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;最后，董事长晏岳军先生拿出现金红包嘉许了优秀的一线员工们。阳光灿烂，岳泰兴人脸上的笑容更灿烂！
`,
        time: '2022-02-25',
    },

    {
        id:3,
        img: '/enter/10.png',
        text: '助力母校，我们在行动',
        info: `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;岳泰兴医疗协助长株潭校友之家及作为家人代表之一向母校岳阳县三中捐赠防疫物资。4月27日，晴朗湛蓝的高空万里无云，由岳泰兴医疗协助长株潭校友之家向岳阳县三中捐赠的防疫物资抵达校园内，受到了各领导的热烈欢迎以及衷心感谢。<br>
        <img style="margin-top: 20px;margin-bottom: 20px;margin-left: 300px" src="/enter/7.png" alt=""><br>
        <img style="margin-top: 20px;margin-bottom: 20px;margin-left: 300px" src="/enter/8.png" alt=""><br>
        <img style="margin-top: 20px;margin-bottom: 20px;margin-left: 300px" src="/enter/9.png" alt=""><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对于这次捐赠活动，岳泰兴医疗的董事长晏岳军先生表示能为母校尽到自己一份微薄力量感到非常荣幸。<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们相信：众人拾柴火焰高，点滴汇聚成大海，大家的爱传递的是一份生命的热度，在我们心底埋下了奉献的种子，在疫情面前，用我们的心、我们的爱、我们的真诚为莘莘学子保驾护航!<br>
`,
        time: '2022/04/27',
    },
    {
        id:8,
        img: '/enter/20.png',
        text: '【湖南岳泰兴医疗科技有限公司】携手雨花经开区，共谋大健康产业新发展',
        info: `
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10月15日下午，雨花经开区大健康产业链供需座谈会召开，雨花经开区管委会易静主任，雨花区人民政府彭婷婷副区长，雨花区卫健局章波书记，雨花经开区产业发展局王琪局长等领导与岳泰兴医疗科技等多家优质企业齐聚一堂，共同研讨大健康产业的发展趋势和机遇，加强产业链上下游企业的深度交流与合作，共同推动产业链优化升级。<br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/20.png" alt=""><br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;会议伊始，雨花经开区大健康产业链办公室介绍了园区当前大健康产业的发展情况。<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;随后湖南岳泰兴医疗科技有限公司董事长晏岳军进行主题发言，并表示：岳泰兴医疗科技期待与各级政府、医疗机构以及产业链上下游伙伴建立更加紧密的合作关系，共同探索医疗健康服务的新模式、新路径。我们相信，通过资源共享、优势互补，能够推动雨花经开区医疗健康产业的创新发展。<br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/21.png" alt=""><br>    
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;雨花区卫健局等领导为企业提供针对性建议和指导，并就大健康产业的发展趋势、政策支持等方面进行深入交流。<br>  
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;与会专家和领导针对如何推动大健康产业的持续健康发展进行深入探讨。他们一致认为，需要加强产业链上下游企业之间的沟通协作，共同打造具有核心竞争力的产业集群；岳泰兴医疗科技也将继续秉承初心，深耕医疗科技，以更加优质的产品和服务，为健康中国战略的实施贡献力量。<br>  
`,
        time: '2024/10/20',
    },
    {
        id:9,
        img: '/enter/22.png',
        text: '湖南省数字赋能医药行业交流会召开',
        info: `
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024年10月18日下午以“数智融合，新质医药”为主题的《2024第四届湖南省数字赋能医药行业交流会暨2024年长沙市岳阳商会卫生健康行业资源对接会》召开，湖南省工商业联合商协会党委专职副书记、党委办公室主任朱冬成，长沙市岳阳商会党委书记、会长李志兵，湖南省数字经济促进会会长黄辉，湖南省数字经济促进会秘书长罗沙，湖南省数字经济促进会医药分会会长童华等领导出席会议。<br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/22.png" alt=""><br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;会议伊始，先由岳阳商会李会长等三位领导发表致辞，并进行相关签约活动，下半场则转入企业主题分享环节。<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;随后湖南岳泰兴医疗科技有限公司副总经理尹宏祥分享《智启未来，数实互动》，围绕医药企业数智化转型的核心理念，全面阐述了全生命周期管理的重要性，深入剖析了当前面临的挑战与应对措施，并详细分享了实施数智化转型的有效路径，为听众提供了宝贵的经验与见解。<br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/23.png" alt=""><br>    
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;此次盛会汇聚了医药行业的众多精英，深入探讨了数字技术在该领域的应用与广阔前景，有效促进了资源的精准对接与深度合作。<br>  
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;岳泰兴医疗科技秉承“用科技服务人类健康”的理念，推动大健康事业的发展。同时，公司也积极响应国家“互联网+医疗健康”的政策，持续推动技术创新和产品升级，为打造成中国领先、国际知名的世界品牌而阔步前进！成为大健康行业佼佼者！<br>  
`,
        time: '2024/10/20',
    },
    {
        id:10,
        img: '/enter/24.png',
        text: '雨花区委统战部、区工商联领导一行莅临指导工作',
        info: `
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024年10月11日重阳节，雨花区委统战部常务副部长谢锋，雨花区委统战部副部长、区工商联党组书记刘助斌携雨花区青商会会长肖柏林会长等人走访岳泰兴。就公司经营情况及公司产品进行考察调研。公司董事长晏岳军、总经理晏岳民，副总经理顶卫云科技总经理尹宏祥等人对领导们前来考察调研表示热烈欢迎并进行热情接待。<br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/24.png" alt=""><br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;董事长晏岳军带领领导们参观公司办公场所、详细介绍生产规模、经营情况、经济效益、未来发展规划及目前面临的困难与挑战。<br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/25.png" alt=""><br>    
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;会议中对岳泰兴的构架和产品跟谢锋常务副部长和刘助斌书记等人做了详细汇报。<br>  
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/26.png" alt=""><br>   
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;岳泰兴是一家致力于大健康领域的高新技术企业，核心围绕医疗机构信息化系统建设与康复理疗设备研发生产销售，拥有岳泰兴大健康商城平台、岳泰兴智慧医院、岳泰兴互联网医院、岳泰兴智慧养老、岳泰兴多种康复理疗设备康养产品等产品体系，数智化布局运营线上线下。 随后并汇报了子公司顶卫云科技的云商企平台<br>  
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/27.png" alt=""><br>  
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;顶卫云科技智慧商协会系统通过信息化技术与商协会业务的深度融合，实现商协会工作全流程智慧化管理<br>  
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 以推进社会组织数字化转型为初心，秉承：“共生 共创 共进”的理念，围绕政府、社会组织、会员企业、个人在内的多个主体展开，塑造商协会相互扶持、跨界发展的合作模式，大幅提升商协会工作效率与会员企业参与度，为商协会组织带来高度的便捷与革新。<br>  
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/28.png" alt=""><br>  
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;会议中谢锋常务副部长和刘助斌书记等人对公司给予了肯定并提出了宝贵的建议，我们将积极吸取宝贵意见，不断优化升级，致力于提供更契合、更高效的服务体验，为客户提供更有价值的产品。<br>  
`,
        time: '2024/10/14',
    },


    {
        id:6,
        img: '/enter/18.png',
        text: '岳泰兴 | 冬季防疫防传染病首推岳泰兴爆款医用外科口罩',
        info: `
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;随着气温降低，我国进入了流行性疾病高发的秋冬季，且新冠疫情亦未完全消灭。因此我们建议，秋冬季出行，尤其是前往人群密集的场所，一定要佩戴正规的防护力强口罩如医用外科口罩。经过疫情，全国人民已形成共识，在公共场所佩戴口罩是讲文明、讲卫生的行为，是对自身及他人身体健康负责人的体现。<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如今青岛等地又出现了新的疫情，今年注定不平凡。在疫情面前，我们应该提高戴口罩的意识，将戴口罩作为一种文明，先进的体现，既不让人戒备，也不被传染。<br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/16.png" alt=""><br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;岳泰兴医用外科口罩<br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/17.png" alt=""><br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;岳泰兴医用外科口罩不仅设计美观，而且携带方便，采用自粘封口设计，是人们居家工作旅行必备之物！医用外科口罩病菌过滤效率大于等于95%，对细菌病菌起到很好的阻隔，对于高风险人流聚集地或从事医院工作建议采用医用外科口罩。
        `,
        time: '2022/02/14',
    },
    {
        id:5,
        img: '/enter/15.png',
        text: '岳泰兴医疗助力雨花防疫工作',
        info: `
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2020年2月14日<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;湖南岳泰兴医疗器械有限公司董事长晏岳军代表公司分别向长沙市雨花区市场监督管理局、洞井市场监督管理所、洞井街道城管办等单位捐赠了一批用于防疫的75%医用酒精、84消毒液以及医用无菌橡胶手套等物资，受到了各部门领导的热烈欢迎以及衷心感谢。<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;岳泰兴董事长晏岳军表示：很感谢奋斗在防疫一线的广大基层干部辛勤的付出，作为辖区的企业，岳泰兴很荣幸能为雨花区的防疫工作奉献一份力量！<br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/11.png" alt="">
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 10px" src="/enter/12.png" alt=""><br>
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 250px" src="/enter/13.png" alt="">
<img style="margin-top: 20px;margin-bottom: 20px;margin-left: 10px" src="/enter/14.png" alt=""><br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;抗击疫情，人人有责，我们岳泰兴人敢于担起责任。凝心聚力，我们在行动，相信一定会战胜疫情！
        `,
        time: '2022/02/14',
    },

    {
        id:4,
        img: '/enter/4.png',
        text: '人工智能产品：岳泰兴智慧导诊导航一体机重磅上线',
        info: `<img  style="margin-top: 20px;margin-bottom: 20px;width: 800px" src="/enter/6.png" alt="">`,
        time: '2022-12-22',
    },

]

